let $elements = $('[data-select]');
let dataAttrPlaceholder = 'select-placeholder';
let $elementsLinks = $('.js-select-links');

var $selectElements = $elements;

$selectElements.each(function (i, el) {
	
	var $el = $(el);
	
	addPlaceholderOption($el);
	
	$el.niceSelect();
	
});

$elementsLinks.change(function(){
	window.location = this.value;
});

function addPlaceholderOption($el) {
	
	var placeholderText = $el.data(dataAttrPlaceholder);
	
	if (placeholderText) {
		
		$el.prepend('<option value="" disabled>' + placeholderText + '</option>');
		$el.val('');
		
	}
	
}